import BaseModel from './BaseModel';
import * as AT from '../../components/container/attributes';
import {HitOnlineEnums} from '@/../../app/src/helpers/constants';

export default class GeneralAccount extends BaseModel {
  constructor({
    id,
    number,
    designation,
    accountType = undefined,
    titleLevel = undefined,
    customData = undefined,
  }) {
    super(id, number, designation);
    this.accountType = accountType;
    this.titleLevel = titleLevel;
    this.customData = customData;
  }

  static get fkName() {
    return 'account_id';
  }
  static get apiRoute() {
    return 'account';
  }
  static get listPageRoute() {
    return 'generalAccountList';
  }
  static get detailPageRoute() {
    return 'generalAccountList';
  }
  static get createInitColumns() {
    return {};
  }
  static get config() {
    const config = BaseModel.config;
    config['addable'] = false;
    return config;
  }
  get fkName() {
    return GeneralAccount.fkName;
  }
  get apiRoute() {
    return GeneralAccount.apiRoute;
  }
  get detailPageRoute() {
    return GeneralAccount.detailPageRoute;
  }
  get listPageRoute() {
    return GeneralAccount.listPageRoute;
  }
  get config() {
    return GeneralAccount.config;
  }

  static get listDisplayAttrs() {
    return this.getAttributes(
      ['convertedType', 'number', 'designation'],
      ['accountType', 'titleLevel', 'customData'],
    );
  }

  static get browserDisplayAttrs() {
    return this.getAttributes(
      ['number', 'designation'],
      ['accountType', 'titleLevel', 'customData'],
    );
  }
  static get joinAttrsKey() {
    return ['number', 'designation', 'accountType'];
  }

  static get allAttributes() {
    return [
      new AT.NotFetchedAttribute({
        name: 'convertedType',
        tableProperties: {
          header: 'hit-app.common.account-type',
          maxWidth: '0.5fr',
        },
      }),
      this.NUMBER_ATTRIBUTE(),
      this.DESIGNATION_ATTRIBUTE(),
      new AT.EnumerationAttribute({
        name: 'accountType',
        enumType: 'ACCOUNT_TYPE',
        enumClass: HitOnlineEnums,
        column: 'account_type',
        tableProperties: {
          header: 'hit-app.common.account-type',
          maxWidth: '1fr',
        },
      }),
      new AT.IntegerAttribute({
        name: 'titleLevel',
        column: 'title_level',
      }),
      new AT.JsonObjectAttribute({
        name: 'customData',
        column: 'custom_data',
      }),
    ];
  }
}
